/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ETicketLayoutStyle } from 'app/modules/design/e-ticket-design/e-ticket-design-management/models/e-ticket-layout-style';
import { LayoutPickerComponent } from './layout-picker.component';
const customValueProvider = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => ETicketLayoutPickerComponent),
	multi: true,
};
const customValidateProvider = {
	provide: NG_VALIDATORS,
	useExisting: forwardRef(() => ETicketLayoutPickerComponent),
	multi: true,
};
@Component({
	selector: 'e-ticket-layout-picker',
	templateUrl: './layout-picker.component.html',
	styleUrls: ['./e-ticket-layout-picker.component.scss'],
	providers: [customValueProvider, customValidateProvider],
	standalone: false,
})
export class ETicketLayoutPickerComponent extends LayoutPickerComponent {
	getIcons(id: number): string[] {
		switch (id) {
			case 1:
				return ['image'];
			case 2:
				return ['image', 'article'];
			case 3:
				return ['article', 'insert_photo'];
			case 4:
				return ['article'];
			default:
				return [];
		}
	}

	getLabel(id: number): string {
		switch (id) {
			case 1:
				return 'Full Width Image';
			case 2:
				return 'Image and Text';
			case 3:
				return 'Text and Image';
			case 4:
				return 'Full Width Text';
			default:
				return '';
		}
	}

	getTooltip(id: number): string {
		switch (id) {
			case 1:
				return 'the uploaded image should be 1424 pixels x 570 pixels';
			case 2:
			case 3:
				return 'the uploaded image should be 712 pixels x 570 pixels';
			default:
				return '';
		}
	}
}
